<template>
    <form-dropdown
        v-if="hasTags"
        id="dropdown-tags"
        ref="tags"
        :settings="newTagSettings"
        :placeholder="''"
        :disabled="! hasTags || form.busy"
        :dropdown-class="'selectize-contacts'"
        :error="form.errors.get('tags')"
        @input="handleChange"
    />
</template>

<style scoped>
    .selectize-input { cursor: pointer; }
</style>

<script>
import TagsMixin from '../../../mixins/tags';

export default {
    mixins: [TagsMixin],

    props: {
        form: {
            type: Object,
            required: true
        }
    },

    computed: {
        newTagSettings() {
            return Object.assign(this.tagSettings, {
                maxItems: null,
                preload: true,
                create: false,
                showCounts: true,
                dropdownParent: 'body',
            });
        },

        selectize() {
            if (!this.$refs.tags) return;

            return this.$refs.tags.$refs.dropdown.$el.selectize;
        },
    },

    methods: {
        handleChange(value) {
            this.form.tags = value;
        },

        handleSetValue(tags) {
            if (!this.selectize) return;

            if (!tags.length) {
                this.selectize.setValue(tags);
            } else {
                tags.forEach(item => {
                    this.selectize.setValue(item);
                });
            }
        }
    },

    mounted() {
        setTimeout(() => {
            try {
                this.handleSetValue(this.form.tags);
            } catch (e) {
                this.$log.error(e, this.$options.__file, 'mounted');
            }
        }, 500);
    }
};
</script>
